import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import ItemRow from './ItemRow';
import './list.css';
import { orderBy } from 'natural-orderby';



class List extends Component {
  componentDidMount() {
    const { listTimeDeposits, googleAnalytics, list } = this.props;
    listTimeDeposits();
    this.compled = true;
    if (list.length > 0) {
      googleAnalytics({ 'event': 'vpv-privado', 'sitesection': 'vpv-privado', 'page': '/tef/dap/resumen' });
    }
  }

  redirect(page) {
    return <Redirect to={page} />;
  }

  render() {
    const { list } = this.props;
    const sortedUsers = orderBy(list,[list => list.fechaVencimiento,list => list.id],['asc','asc']);
    console.log(sortedUsers);
    if (list.length < 1 && this.compled) {
      return this.redirect("/Simulador");
    }

    return (
      <div className="ItemRow">
        {
          sortedUsers.map(dap => {
            return <ItemRow key={dap.id} dap={dap} />;
        })
        }
      </div>
    );
  }
}

export default List;
